import { View, Text, styled, ScrollView } from 'tamagui'
import { Users, Search } from '@tamagui/lucide-icons'
import { useAppStore } from '@/store'
import { dmChannels } from '@/mocks/dms'
import { users } from '@/mocks'
import { DMConversationItem } from '../app/dm/DMConversationItem'

const Sidebar = styled(View, {
  width: 240,
  backgroundColor: '$sidebar',
  flexDirection: 'column',
  flexShrink: 0,
  borderRightWidth: 1,
  borderRightColor: '$borderDefault',
})

const SidebarHeader = styled(View, {
  height: 48,
  paddingHorizontal: 12,
  flexDirection: 'row',
  alignItems: 'center',
  gap: 8,
  borderBottomWidth: 1,
  borderBottomColor: '$borderDefault',
})

const SearchBox = styled(View, {
  flex: 1,
  height: 28,
  borderRadius: '$borderRadiusMd',
  backgroundColor: '$surfaceRaised',
  flexDirection: 'row',
  alignItems: 'center',
  paddingHorizontal: 8,
  gap: 6,
})

const SearchText = styled(Text, {
  fontFamily: '$fontBody',
  fontSize: 12,
  color: '$color8',
})

const FriendsButton = styled(View, {
  flexDirection: 'row',
  alignItems: 'center',
  height: 36,
  paddingHorizontal: 12,
  marginHorizontal: 8,
  marginTop: 8,
  borderRadius: '$borderRadiusMd',
  gap: 8,
  cursor: 'pointer',
  hoverStyle: {
    backgroundColor: '$sidebarHover',
  },
  variants: {
    active: {
      true: {
        backgroundColor: '$sidebarActive',
      },
    },
  } as const,
})

const FriendsLabel = styled(Text, {
  fontFamily: '$fontBody',
  fontSize: 14,
  fontWeight: '500',
  color: '$surfaceForeground',
})

const SectionLabel = styled(Text, {
  fontFamily: '$fontBody',
  fontSize: 11,
  fontWeight: '600',
  color: '$color8',
  textTransform: 'uppercase',
  letterSpacing: 0.5,
  paddingHorizontal: 16,
  paddingTop: 16,
  paddingBottom: 4,
})

export function DMSidebar() {
  const { activeDmChannelId, setActiveDmChannel, navigateToDms } = useAppStore()

  return (
    <Sidebar>
      <SidebarHeader>
        <SearchBox>
          <Search size={12} color="$color8" />
          <SearchText>Find a conversation</SearchText>
        </SearchBox>
      </SidebarHeader>

      <FriendsButton
        active={!activeDmChannelId}
        onPress={() => {
          navigateToDms()
          // Clear DM selection to show friends list
          useAppStore.setState({ activeDmChannelId: null })
        }}
      >
        <Users size={16} color={!activeDmChannelId ? '$accent' : '$sidebarMuted'} />
        <FriendsLabel>Friends</FriendsLabel>
      </FriendsButton>

      <SectionLabel>Direct Messages</SectionLabel>

      <ScrollView flex={1} showsVerticalScrollIndicator={false}>
        <View paddingVertical={4}>
          {dmChannels.map((dm) => {
            const otherUserId = dm.participantIds.find(id => id !== 'u1') || ''
            const otherUser = users[otherUserId]
            if (!otherUser) return null
            return (
              <DMConversationItem
                key={dm.id}
                dm={dm}
                user={otherUser}
                isActive={activeDmChannelId === dm.id}
                onPress={() => setActiveDmChannel(dm.id)}
              />
            )
          })}
        </View>
      </ScrollView>
    </Sidebar>
  )
}
